import * as React from "react";
import { Checkbox, Text } from "../../elements";
import { PoseGroup } from "react-pose";
import GroupSelectorItems, { hasItemsSelected } from "./GroupSelectorItems";
import { ItemProps } from "./";

import {
  ItemBase,
  ItemInner,
  ItemMain,
  ItemsOuter,
  PlusToMinIcon
} from "./styles";

function GroupSelectorItem({
  title,
  id,
  selected,
  items,
  onChange, // react conventie => onChange
  open: externalOpen,
  level,
  parentSelected,
  showOnlySelected
}: ItemProps & {
  onChange: (id: ItemProps["id"], selected: ItemProps["selected"]) => void;
  level?: number;
  parentSelected?: boolean;
  showOnlySelected?: boolean;
}) {
  const [open, setOpen] = React.useState(externalOpen);

  React.useEffect(() => {
    setOpen(externalOpen);
  }, [externalOpen]);

  return (
    <ItemBase showBorderBottomOnLastChild={level === 1}>
      <ItemInner indentation={!level ? 0 : level * 30 - 20}>
        <ItemMain onClick={() => setOpen(!open)}>
          {items && <PlusToMinIcon value={open || false} />}
          <Text c={["grey", 7]} fs={-1} fw={level === 1 ? "bold" : "normal"}>
            {title}
          </Text>
        </ItemMain>
        <Checkbox
          partial={hasItemsSelected(items)}
          value={parentSelected || selected}
          onClick={() => onChange(id, selected)}
        />
      </ItemInner>
      <PoseGroup flipMove={false}>
        {items && open && (
          <ItemsOuter key="menu">
            <GroupSelectorItems
              items={items}
              key="menu"
              parentSelected={selected === true}
              onChange={onChange}
              level={level}
              showOnlySelected={showOnlySelected}
            />
          </ItemsOuter>
        )}
      </PoseGroup>
    </ItemBase>
  );
}

export default GroupSelectorItem;
